import React from 'react';
import './styles.css';
import P from 'prop-types';
import { LabelPreco } from '../../components/LabelPreco';
import { Button } from '../../components/Button';

export const Adicionais = ({ data, somar, subtrair, handleQtdeSelecionada }) => {
  const qtdeSelecionada = handleQtdeSelecionada(data.Titulo);
  let descricao = data.Produto.descricao.toLowerCase();
  if (data.Produto.quantidade > 0 && data.Produto.tipo_produto?.toUpperCase() === 'PIZZA')
    descricao = descricao + ' (' + data.Produto.quantidade + ')';

  let disabled = false;
  if (data.TipoMontagem === 'COMBO' || data.TipoMontagem === 'OBRIGATORIO') {
    if (qtdeSelecionada > 0 && data.QtdeObrigatoria === qtdeSelecionada) disabled = true;
    //if (data.QtdeSelecionada > 0 && data.QtdeObrigatoria === data.QtdeSelecionada) disabled = true;
  } else if (data.TipoMontagem === 'ADICIONAL') {
    if (qtdeSelecionada > 0 && data.QtdMaxima > 0 && data.QtdMaxima === qtdeSelecionada) disabled = true;
    //if (data.QtdeSelecionada > 0 && data.QtdMaxima > 0 && data.QtdMaxima === data.QtdeSelecionada) disabled = true;
  }

  return (
    <span className="montagem_container">
      <div className="montagem_descricao">
        {/* {data.Produto.descricao.toLowerCase() + ' (' + data.Produto.quantidade > 0 ? data.Produto.quantidade : +')'} */}
        {descricao}
        {data.Produto.obs_produto !== '' && (
          <span className="montagem_observacao">{data.Produto.obs_produto.toLowerCase()}</span>
        )}

        {data.TipoMontagem !== 'COMBO' && data.Produto.preco_app > 0 && (
          <LabelPreco className="montagem_preco" price={data.Produto.preco_app} />
        )}
      </div>
      <div className="button_container">
        {data.Produto.quantidade > 0 && <Button icon="remove" className="btn_adicionais" onClick={subtrair} />}
        {data.Produto.quantidade > 0 && data.TipoMontagem === 'PIZZA' && (
          <span className="label_quantidade">{data.Produto.quantidade_texto}</span>
        )}
        {data.Produto.quantidade > 0 && data.TipoMontagem !== 'PIZZA' && (
          <span className="label_quantidade">{data.Produto.quantidade}</span>
        )}
        <Button
          icon="add"
          className="btn_adicionais"
          disabled={disabled}
          classDisabled="btnDisabledTransparent"
          onClick={somar}
        />
      </div>
    </span>
  );
};

Adicionais.propTypes = {
  data: P.object,
  somar: P.func,
  subtrair: P.func,
  handleQtdeSelecionada: P.func,
};
